// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__utjrG","footer":"styles_footer__1mo0X","passCodeTooltip":"styles_passCodeTooltip__27p9y"};